import React,{useState,useEffect} from "react";
import { Link } from 'react-router-dom';
import { Layout, Menu } from "antd";
import { PoweroffOutlined, UserOutlined } from '@ant-design/icons';
import logo from "../../imgs/logo_iteprevengo.png";
import logo_gestiona from "../../imgs/logo_gestiona.png";

// import "../../styles/kernel.scss";


import {userSignOut} from "../../appRedux/actions/Auth";
import {useDispatch, useSelector} from "react-redux";

const { Header} = Layout;

const NavBar = ({ origin }) => {
    const dispatch = useDispatch();
    
    return(
        <Header className="navBar" style={{ position: 'fixed', zIndex: 1, width: '100%' }}
        >
            <div className={origin==='gestiona' ? 'logo_gestiona' : origin==='tecda' ? 'logo_tecda' : ''} />

         
        
        </Header>
    );

}

export default NavBar;